import { render } from "./addNewOrganisation.vue?vue&type=template&id=9a579d1a&ts=true"
import script from "./addNewOrganisation.vue?vue&type=script&lang=ts"
export * from "./addNewOrganisation.vue?vue&type=script&lang=ts"

import "./addNewOrganisation.vue?vue&type=style&index=0&id=9a579d1a&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__